import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Loading from 'Webapp/shared/app/components/loading';
import PageClasses from 'Webapp/shared/app/components/page-classes';
import WebLink from 'Webapp/shared/app/components/web-link';
import SitemapHeader from 'Webapp/shared/app/components/sitemap/sitemap-header';
import SitemapItem from 'Webapp/shared/app/components/sitemap/sitemap-item';

import { SPACING } from 'Style/spacing';
import { COLORS, TEXT_COLORS } from 'Style/colors';
import { BREAKPOINTS } from 'Style/breakpoints';
import { UI_SUBHEADING_TYPES } from 'Style/typography';

import withT from 'ComponentLibrary/hocs/withT';
import withBreadcrumbs from 'Webapp/shared/app/hocs/withBreadcrumbs';

const Sitemaps = styled.div(
  {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: SPACING.XLARGE,
    rowGap: SPACING.XLARGE,
  },
  BREAKPOINTS.tabletPortraitDown({
    gridTemplateColumns: '1fr',
  }),
);

const SitemapSection = styled.section({});

const SitemapSectionList = styled.div({
  'ul li': {
    marginBottom: SPACING.SMALL,
  },
});

const SitemapSectionHeader = styled.h2(
  {
    textTransform: 'capitalize',
    marginBottom: SPACING.MEDIUM,
    a: {
      color: TEXT_COLORS.primary,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  UI_SUBHEADING_TYPES.LARGE_STANDARD,
);

const SeeMore = styled(WebLink)({
  color: COLORS.red,
  marginTop: SPACING.LARGE,
  display: 'block',
});

class SitemapIndex extends React.Component {
  componentDidMount() {
    const {
      index: { loaded },
      getSitemapIndex,
      setBreadcrumbs,
    } = this.props;
    if (!loaded) {
      getSitemapIndex();
    }
    setBreadcrumbs({ sitemapIndex: true });
  }

  sitemapSection(type) {
    const { t, index } = this.props;
    return (
      <SitemapSection>
        <SitemapSectionHeader>
          <WebLink href={`/sitemap/${type}`}>{t(type)}</WebLink>
        </SitemapSectionHeader>
        <SitemapSectionList>
          <ul>
            {index.types[type].items.map((item) => (
              <li key={item.url}>
                <SitemapItem item={item} />
              </li>
            ))}
          </ul>
          <SeeMore href={`/sitemap/${type}`}>{t('see_more')}</SeeMore>
        </SitemapSectionList>
      </SitemapSection>
    );
  }

  render() {
    const { loading } = this.props;
    if (loading) {
      return <Loading isView />;
    }
    return (
      <PageClasses>
        <SitemapHeader>Sitemap</SitemapHeader>
        <Sitemaps>
          {this.sitemapSection('topics')}
          {this.sitemapSection('profiles')}
          {this.sitemapSection('storyboards')}
        </Sitemaps>
      </PageClasses>
    );
  }
}

SitemapIndex.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  index: PropTypes.object.isRequired,
  getSitemapIndex: PropTypes.func.isRequired,
  setBreadcrumbs: PropTypes.func.isRequired,
};

export default withBreadcrumbs(withT(SitemapIndex));
